import { render, staticRenderFns } from "./AuthTelegramDialog.vue?vue&type=template&id=5173081c"
import script from "./AuthTelegramDialog.vue?vue&type=script&lang=js"
export * from "./AuthTelegramDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports